import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from './crud.service';
import {DigitalReceipt, TestOrder} from '../_models';
import {Observable} from 'rxjs';

@Injectable()
export class ResolveMerchantService extends CrudService {
  constructor(protected http: HttpClient) {
    super(http, 'resolve_merchants');
  }

  sendTestOrder(id: string | number, data: TestOrder): Observable<DigitalReceipt> {
    return <Observable<DigitalReceipt>>this.http.post(this.route + '/' + id.toString() + '/test_order/', data);
  }
}
